import { render, staticRenderFns } from "./Annotations.vue?vue&type=template&id=5566c236&"
import script from "./Annotations.vue?vue&type=script&lang=js&"
export * from "./Annotations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports